var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('marks-list'),_c('competency-mark-card',{attrs:{"item":_vm.item}}),_c('marks-list-second-variant'),_c('avatars-group',{attrs:{"items":_vm.hardSkills,"background-color":'lightblue'}}),_c('avatars-group',{attrs:{"items":_vm.softSkills,"background-color":'lightgreen'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }